import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApiClientAmbassador } from '~/@api/client/useApiClientAmbassador'
import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'
import { useUser } from '~/@biz_account/useUser/useUser'
import type { IMyAmbassadorClaimRequest } from '~/@api/generated-api-types-ambassador/Api'
import { useAmbassadorCode } from '~/@biz_ambassador/code/useAmbassadorCode'

const MY_AMBASSADOR_QUERY_KEY = ['my-ambassador']

export function useMyAmbassador({
  enabled = true,
}: { enabled?: boolean } = {}) {
  const api = useApiClientAmbassador()
  const queryClient = useQueryClient()
  const { setNotification } = useLocalNotifications()
  const { reloadUser } = useUser()
  const { removeAmbassadorCode } = useAmbassadorCode()

  const query = useQuery({
    queryKey: MY_AMBASSADOR_QUERY_KEY,
    enabled,
    queryFn: async () => {
      try {
        const resp = await api.user.myAmbassadorControllerGetMyAmbassador({
          secure: true,
        })
        return resp.data.data ?? null
      } catch (error) {
        // 404 => the user has not claimed an ambassador yet
        if ((error as Response)?.status === 404) {
          return null
        }
        throw error
      }
    },
  })

  const claimMutation = useMutation({
    mutationFn: async (params: IMyAmbassadorClaimRequest) =>
      api.user.myAmbassadorControllerClaimMyAmbassador(params, {
        secure: true,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MY_AMBASSADOR_QUERY_KEY })
      void reloadUser()
      removeAmbassadorCode()
      setNotification('success', 'Ambasádor bol úspešne priradený.')
    },
  })

  return { query, claimMutation }
}
